import type { BrandingTokens } from "../api/generated/contracts";

/**
 * Overwrites the `--eg-color-*` CSS custom properties from a runtime BrandingTokens payload
 * (RoadmapView.Branding, DeckVersionDetail's frozen branding, etc.), so the static defaults in
 * theme/tokens.css are seed values only - no component ever reads a hex literal
 * (decomposition.md section 6.2). Session 4 has no `GET /api/config/branding` read route (the
 * Configuration surface only exposes PUT per ConfigurationController.cs), so the shell paints
 * with the static defaults until the first roadmap or deck-detail fetch supplies real tokens;
 * a later session should call this from wherever BrandingTokens first arrives.
 */
export function applyBrandingTokens(tokens: BrandingTokens, root: HTMLElement = document.documentElement): void {
  for (const [name, hex] of Object.entries(tokens.colors)) {
    root.style.setProperty(`--eg-color-${name}`, hex);
  }
}
